import React from "react";
import '../../css/Components.css'

const Item =({src,title,price,setDetail,setModal,suburl,explan,option})=>{

    return(
        <>
            <div className={'item-container'}>
                <img src={src} alt={'item'} className={'item-img'}/>
                <div className={'item-container-inner-chg'}>
                    <div className={"item-container-inner-col"}>
                        <h4>{title}</h4>
                        <span>{price}원</span>
                    </div>
                    <div className={'flex__low'}>
                        <div className={'item-button background-color-grey'} onClick={()=>{
                            setDetail({name: title, price: price, url:src,explan:explan,suburl:suburl,option:option});
                            setModal(true);
                        }}>
                            상세보기
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Item;
